import { createContext } from "react";

export const UserDetailsContext = createContext({});

export default UserDetailsContext;
